import { render, staticRenderFns } from "./TemplatePortraitFrameNew.vue?vue&type=template&id=522133cb&scoped=true&"
import script from "./TemplatePortraitFrameNew.vue?vue&type=script&lang=js&"
export * from "./TemplatePortraitFrameNew.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePortraitFrameNew.vue?vue&type=style&index=0&id=522133cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522133cb",
  null
  
)

export default component.exports